import React from 'react';
import { Message } from '@forwardfinancing/component-library';

class SomethingWentWrongMessage extends React.Component {
  render() {
    const route = "https://www.forwardfinancing.com";
    return (
      <div className="something-went-wrong">
        <div className="nav-left">
          <a href={route} className="nav-item is-brand">
              <img
                src="https://commonassets.forwardfinancing.com/media/newLogo.png"
                alt="Forward Financing Logo"
                width="270px"
                height="90px"
              />
          </a>
        </div>
        <div className="something-went-wrong--message">
          <Message
            mainMessage="Please Try Again Later"
            secondaryMessage="Something has gone wrong."
            buttonDisplayVal="Forward Financing Home"
            buttonLink={route}
          />
        </div>
      </div>
    );
  }
}

export default SomethingWentWrongMessage;
